import { createAction } from '@reduxjs/toolkit';
import * as containerConstants from './constants';
import type { Vendor } from '@/lib/types';

export const loadVendors = createAction(containerConstants.LOAD_VENDORS);

export const loadVendorsSuccess = createAction(
  containerConstants.LOAD_VENDORS_SUCCESS,
  (vendors: any[]) => ({ payload: { vendors } })
);

export const loadVendorsError = createAction(
  containerConstants.LOAD_VENDORS_ERROR,
  (error: string) => ({ payload: { error } })
);

export const saveVendorRequest = createAction(
  'vendors/SAVE_VENDOR_REQUEST',
  (vendor: Vendor, isNew: boolean) => ({ payload: { vendor, isNew } })
);

export const deleteVendorRequest = createAction(
  'vendors/DELETE_VENDOR_REQUEST',
  (id: string) => ({ payload: { id } })
);
